import axios from "utils/axios";
import { API } from "constants/api";

// Types
import { IPaceAssessmentReport } from "store/slice/Pace/paceSlice.types";
import { AxiosResponse } from "axios";

interface TPaceAssessmentReportServiceResponse {
    data: IPaceAssessmentReport;
}

export const getAssessmentReportService = (
    userId: number,
    assessmentId: number,
    groupId?: number
): Promise<TPaceAssessmentReportServiceResponse> => {
    const url = groupId
        ? `${API.PACE.GROUP}/${groupId}/user/${userId}/assessment/${assessmentId}/report`
        : `${API.PACE.USER}/${userId}/assessment/${assessmentId}/report`;

    return axios.get(url);
};

export const getAssessmentReportServicePDF = (
    userId: number,
    assessmentId: number,
    groupId?: number
): Promise<AxiosResponse<Blob>> => {
    const url = groupId
        ? `${API.PACE.GROUP}/${groupId}/user/${userId}/assessment/${assessmentId}/report`
        : `${API.PACE.USER}/${userId}/assessment/${assessmentId}/report`;

    return axios.get(url, {
        headers: { Accept: "application/pdf" },
        responseType: "blob",
    });
};
